import { render, staticRenderFns } from "./SelectBranch.vue?vue&type=template&id=4589de95"
import script from "./SelectBranch.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectBranch.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4589de95')) {
      api.createRecord('4589de95', component.options)
    } else {
      api.reload('4589de95', component.options)
    }
    module.hot.accept("./SelectBranch.vue?vue&type=template&id=4589de95", function () {
      api.rerender('4589de95', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/company/branch/components/SelectBranch.vue"
export default component.exports